// src/hooks/useSocketIO.ts
'use client'

import { useEffect, useState } from 'react'
import { io, Socket } from 'socket.io-client'

export const useSocketIO = (uri: string): Socket | null => {
  const [socket, setSocket] = useState<Socket | null>(null)

  useEffect(() => {
    const newSocket = io(uri, { transports: ['websocket'], addTrailingSlash: false })
    setSocket(newSocket)

    return () => {
      newSocket.close()
    }
  }, [setSocket, uri])

  return socket
}
